"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var reactjs_popup_1 = require("reactjs-popup");
var React = require("react");
require("./ToolTip.scss");
var ToolTip = function (props) {
    var iconSize = props.iconSize ? props.iconSize : 24;
    return (React.createElement("span", { className: "eos-tooltip" },
        React.createElement(reactjs_popup_1.default, { position: props.position, trigger: function () { return React.createElement("i", { className: "icon-info tool-tip-icon", "data-test": props.dataTestIdTrigger, style: { fontSize: iconSize } }); }, closeOnDocumentClick: true },
            React.createElement("div", { className: "modal", "data-test": props.dataTestIdContent }, props.text))));
};
exports.default = ToolTip;
//# sourceMappingURL=ToolTip.js.map